import { Button, deviceConstraints } from '@toggle/design-system';
import styled, { css } from 'styled-components';

export const Header = styled.div<{ $isSummary: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  align-items: center;

  ${({ $isSummary }) =>
    !$isSummary &&
    css`
      margin-bottom: 14px;
    `}
`;

export const DropdownWrapper = styled.div<{ $isGrid: boolean }>`
  padding: 6px 0;

  ${Button.Styled.Text} {
    max-width: 130px;

    @media ${deviceConstraints.desktop} {
      max-width: 180px;
    }
  }

  ${({ $isGrid }) =>
    !$isGrid &&
    css`
      ${Button.Styled.Text} {
        max-width: 280px;
      }
    `}
`;

export const ActionButtons = styled.div`
  padding: 6px 0;
  display: flex;
  gap: 12px;
`;

export const WatchlistSummaryActions = styled.div<{ $isGrid: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-radius: 4px 4px 0 0;

  background: var(--surface-default);
  padding: 6px 8px;
`;

export const ActiveTab = styled(Button)`
  pointer-events: none;
  color: var(--text-primary);
  svg {
    fill: var(--text-primary);
  }
`;
